/**
 * To please https://developer.chrome.com/docs/lighthouse/best-practices/uses-passive-event-listeners/?utm_source=lighthouse&utm_medium=lr
 * we make scroll and touchstart events "passive"
 * https://v12.angular.io/guide/event-binding#binding-to-passive-events
 * AND FOR SOME REASONS THIS IS NOT AFFECTING TOUCH EVENTS IN ANGULAR - WAITING FOR BUGFIXES
 */
window['__zone_symbol__PASSIVE_EVENTS'] = ['scroll', 'touchstart', 'touch', 'touchend', 'touchmove', 'wheel'];

// make sure to check that your app is not relying on an API before disabling it!!!

// Not needed for morst of Angular apps
window['__Zone_disable_requestAnimationFrame'] = true;
window['__Zone_disable_canvas'] = true;
window['__Zone_disable_Error'] = true;
window['__Zone_disable_geolocation'] = true;
window['__Zone_disable_toString'] = true;
window['__Zone_disable_blocking'] = true;
window['__Zone_disable_PromiseRejectionEvent'] = true;
window['__Zone_disable_MutationObserver'] = true;
window['__Zone_disable_Intersection'] = true;
window['__Zone_disable_FileReader'] = true;
window['__Zone_disable_IE_check'] = true;
window['__Zone_disable_geolocation'] = true;
window['__Zone_disable_mediaQuery'] = true;
window['__Zone_disable_notification'] = true;
window['__Zone_disable_MessagePort'] = true;
window['__Zone_enable_cross_context_check'] = false;

// Optional for some Angular apps but we use them (heavily)
// (window as any).__zone_symbol__UNPATCHED_EVENTS = ["scroll", "mousemove"];
// (window as any).__Zone_disable_timers = true;
// (window as any).__Zone_disable_XHR = true;
// (window as any).__Zone_disable_on_property = true;

// Needed for all Angular apps
window['__Zone_disable_ZoneAwarePromise'] = false;
window['__Zone_disable_EventTarget'] = false;
